import {appBeforeEnter} from '@/router/navigation.js'

export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/page',
    redirect: '/page/home', // 测试，后期需要删除/page
  },
  {
    path: '/base',
    // component: () => import(/* webpackChunkName: 'base' */ '@/views/BaseView.vue'),
    component: () => import(/* webpackChunkName: 'base' */ '@/views/baseView/BaseView.vue'),
    children: [
      {
        path: '/home',
        // component: () => import(/* webpackChunkName: 'home' */ '@/views/HomeView.vue'),
        component: () => import(/* webpackChunkName: 'home' */ '@/views/homeView/HomeView.vue'),
        beforeEnter: appBeforeEnter,
      },
      {
        path: '/login',
        component: () => import(/* webpackChunkName: 'login' */ '@/views/LoginView.vue'),
        beforeEnter: appBeforeEnter,
        meta: {
          isNotAuth: true,
        },
      },
      {
        path: '/page/home', // 测试，后期需要删除
        component: () => import(/* webpackChunkName: 'home' */ '@/views/HomeView.vue'),
        beforeEnter: appBeforeEnter,
      },
      {
        path: '/page/login', // 测试，后期需要删除
        component: () => import(/* webpackChunkName: 'login' */ '@/views/LoginView.vue'),
        beforeEnter: appBeforeEnter,
        meta: {
          isNotAuth: true,
        },
      },
      {
        path: '/register', // 注册
        component: () => import(/* webpackChunkName: 'registerView' */ '@/views/registerView.vue'),
        beforeEnter: appBeforeEnter,
        meta: {
          isNotAuth: true,
        },
      },
      {
        path: '/main',
        component: () => import(/* webpackChunkName: 'main' */ '@/views/SubMenuView.vue'),
        children: [
          {
            name: 'MobileMenuList',
            path: '/mobileMenuList',
            component: () => import(/* webpackChunkName: 'mobileMenuList' */ '@/views/mobile/MobileMenuListView.vue'),
            beforeEnter: appBeforeEnter,
          },
          {
            name: 'List',
            path: '/list/:listId',
            component: () => import(/* webpackChunkName: 'list' */ '@/views/StaticListView.vue'),
            beforeEnter: appBeforeEnter,
          },
          {
            name: 'Static',
            path: '/static/:staticId',
            component: () => import(/* webpackChunkName: 'static' */ '@/views/StaticView.vue'),
            beforeEnter: appBeforeEnter,
          },
          {
            name: 'PublicWelfareProjectList',
            path: '/publicWelfareProjectList',
            component: () =>
              import(
                /* webpackChunkName: 'publicWelfareProjectList' */ '@/views/publicWelfareProjectListView/PublicWelfareProjectListView.vue'
              ),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 24,
            },
          },
          {
            name: 'PublicWelfareProjectStatic',
            path: '/publicWelfareProjectStatic/:staticId',
            component: () =>
              import(
                /* webpackChunkName: 'publicWelfareProjectList' */ '@/views/publicWelfareProjectStaticView/PublicWelfareProjectStaticView.vue'
              ),
            beforeEnter: appBeforeEnter,
          },
          {
            path: '/contributionView/:staticId',
            component: () => import(/* webpackChunkName: 'contributionView' */ '@/views/contributionView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 24,
            },
          },
          {
            path: '/noticeView', // 会员注册
            component: () => import(/* webpackChunkName: 'noticeView' */ '@/views/noticeView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              isNotMember: true,
              menuId: 20,
            },
          },
          {
            path: '/memberInfoToFillView', // 会员注册时资料填写
            component: () => import(/* webpackChunkName: 'memberInfoToFillView' */ '@/views/memberInfoToFillView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              isNotMember: true,
              menuId: 20,
            },
          },
          {
            path: '/paymentView', // 会员入会支付
            component: () => import(/* webpackChunkName: 'paymentView' */ '@/views/paymentView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              menuId: 20,
            },
          },
          {
            path: '/memberInfoView', // 会员信息
            component: () => import(/* webpackChunkName: 'memberInfoView' */ '@/views/memberInfoView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              isMember: true,
              menuId: 21,
            },
          },
          {
            path: '/membershipInfoView', // 会费信息
            component: () => import(/* webpackChunkName: 'membershipInfoView' */ '@/views/membershipInfoView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              isMember: true,
              menuId: 22,
            },
          },
          {
            path: '/donationPublicityView', // 捐款公示
            component: () =>
              import(/* webpackChunkName: 'donationPublicityView' */ '@/views/donationPublicityView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 25,
            },
          },
          {
            path: '/donationInformationView', // 捐赠信息
            component: () =>
              import(/* webpackChunkName: 'donationInformationView' */ '@/views/donationInformationView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              menuId: 26,
            },
          },
          {
            path: '/personalDataView', // 个人信息
            component: () => import(/* webpackChunkName: 'personalDataView' */ '@/views/personalDataView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              menuId: 47,
            },
          },
          {
            path: '/paymentMnformationView', // 支付信息
            component: () =>
              import(/* webpackChunkName: 'paymentMnformationView' */ '@/views/paymentMnformationView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              isAuth: true,
              menuId: 48,
            },
          },
          {
            path: '/projectPaymentView', // 支付信息
            component: () => import(/* webpackChunkName: 'projectPaymentView' */ '@/views/projectPaymentView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 24,
            },
          },
          {
            path: '/noticeTipsView', // 会员入会支付成功后提示
            component: () => import(/* webpackChunkName: 'noticeTipsView' */ '@/views/noticeTipsView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 20,
            },
          },
          {
            path: '/electronicInvoiceView', // 会员入会支付成功后电子发票
            component: () =>
              import(/* webpackChunkName: 'electronicInvoiceView' */ '@/views/electronicInvoiceView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 20,
            },
          },
          {
            path: '/certificateDownView', // 捐款后证书下载页面
            component: () => import(/* webpackChunkName: 'certificateDownView' */ '@/views/certificateDownView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 24,
            },
          },
          {
            path: '/electronicInvoiceProjectView', // 项目捐款后的发票页面
            component: () =>
              import(/* webpackChunkName: 'electronicInvoiceProjectView' */ '@/views/electronicInvoiceProjectView.vue'),
            beforeEnter: appBeforeEnter,
            meta: {
              menuId: 24,
            },
          },
        ],
      },
      /* {
              path: '/aloneList/:listId',
              name: 'List',
              component: () => import(/!* webpackChunkName: 'list' *!/ '@/views/StaticListView.vue'),
            },
            {
              path: '/aloneStatic/:staticId',
              name: 'Static',
              component: () => import(/!* webpackChunkName: 'static' *!/ '@/views/StaticView.vue'),
            }, */
      /* {
              path: '/certificateDownView', // 证书下载
              component: () => import(/!* webpackChunkName: 'certificateDownView' *!/ '@/views/certificateDownView.vue'),
            }, */
      /* {
              path: '/memberMainView',
              component: () => import(/!* webpackChunkName: 'memberMainView' *!/ '@/views/memberMainView.vue'),
            }, */
    ],
  },
]
